export const StockValidation = (formData) => {
    const errors = {};
  
    // Validate each field
    if (!formData.vc_Name.trim()) {
      errors.vc_Name = 'This field is required';
    } 
  
    return errors;
  };
  
 